module.exports = __webpack_public_path__ + "img/visu-fanage@2x.fea4a592.jpg";